export enum ProvisioningProfileRole {
  adhoc,
  enterprise,
  development,
  unSupported,
}
